<template>
  <!-- 由于日和周的选择会有冲突性，其中一个必然为? 因此将内容写到一个文件中 -->
  <div class="day-and-week-box">
    <RadioGroup @on-change="getValue" size="small" style="width: 100%" v-model="type">
      <!-- 日 -->
      <div class="box-bottom">
        <Radio border label="1" size="small">每日</Radio>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="2" size="small">日周期</Radio>
        <template v-if="type == '2'">
          <span style="margin-right: 0.5rem;">从</span>
          <InputNumber
            :max="31"
            :min="1"
            @on-change="getChangeDay"
            size="small"
            style="width: 4rem;"
            v-model="dayCycle.start"
          ></InputNumber>
          <span style="margin-left: 0.5rem; margin-right: 0.5rem;">至</span>
          <InputNumber
            :max="31"
            :min="2"
            @on-change="getChangeDay"
            size="small"
            style="width: 4rem;"
            v-model="dayCycle.end"
          ></InputNumber>
          <span style="margin-left: 0.5rem;">日</span>
        </template>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="3" size="small">日循环</Radio>
        <template v-if="type == '3'">
          <span style="margin-right: 0.5rem;">从</span>
          <InputNumber
            :max="31"
            :min="1"
            @on-change="getLoopDay"
            size="small"
            style="width: 4rem;"
            v-model="dayLoop.start"
          ></InputNumber>
          <span style="margin-left: 0.5rem; margin-right: 0.5rem;">日开始，每</span>
          <InputNumber
            :max="31"
            :min="1"
            @on-change="getLoopDay"
            size="small"
            style="width: 4rem;"
            v-model="dayLoop.end"
          ></InputNumber>
          <span style="margin-left: 0.5rem;">日执行一次</span>
        </template>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="5" size="small">工作日</Radio>
        <template v-if="type == '5'">
          <span style="margin-right: 0.5rem;">每月</span>
          <InputNumber
            :max="31"
            :min="1"
            @on-change="getworkDay"
            size="small"
            style="width: 4rem;"
            v-model="work"
          ></InputNumber>
          <span style="margin-left: 0.5rem;">号，最近的工作日</span>
        </template>
      </div>
      <div class="box-bottom">
        <Radio border label="6" size="small">月最后一天</Radio>
      </div>
      <div class="box-bottom">
        <Radio border label="7" size="small">月最后一个工作日</Radio>
      </div>
      <!-- 周 -->
      <div class="box-border"></div>
      <div class="box-bottom">
        <Radio border label="11" size="small">每周</Radio>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="12" size="small">周周期</Radio>
        <template v-if="type == '12'">
          <span style="margin-right: 0.5rem;">从星期({{weekFormat[weekCycle.start]}})</span>
          <InputNumber
            :max="7"
            :min="1"
            @on-change="getChangeWeek"
            size="small"
            style="width: 4rem;"
            v-model="weekCycle.start"
          ></InputNumber>
          <span
            style="margin-left: 0.5rem; margin-right: 0.5rem;"
          >至星期({{weekFormat[weekCycle.end]}})</span>
          <InputNumber
            :max="7"
            :min="2"
            @on-change="getChangeWeek"
            size="small"
            style="width: 4rem;"
            v-model="weekCycle.end"
          ></InputNumber>
        </template>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="13" size="small">周循环</Radio>
        <template v-if="type == '13'">
          <span style="margin-right: 0.5rem;">月第</span>
          <InputNumber
            :max="4"
            :min="1"
            @on-change="getLoopWeek"
            size="small"
            style="width: 4rem;"
            v-model="weekLoop.start"
          ></InputNumber>
          <span style="margin-left: 0.5rem; margin-right: 0.5rem;">个星期({{weekFormat[weekLoop.end]}})</span>
          <InputNumber
            :max="7"
            :min="1"
            @on-change="getLoopWeek"
            size="small"
            style="width: 4rem;"
            v-model="weekLoop.end"
          ></InputNumber>
          <span style="margin-left: 0.5rem;">开始执行</span>
        </template>
      </div>
      <div class="box-bottom cycle">
        <Radio border label="15" size="small">月末周</Radio>
        <template v-if="type == '15'">
          <span style="margin-right: 0.5rem;">月最后一个星期({{weekFormat[last]}})</span>
          <InputNumber
            :max="7"
            :min="1"
            @on-change="getlastWeek"
            size="small"
            style="width: 4rem;"
            v-model="last"
          ></InputNumber>
        </template>
      </div>
      <!-- <div class="box-border"></div> -->
      <!--指定 -->
      <div class="box-bottom">
        <Radio border label="4" size="small">指定日</Radio>
        <Select
          @on-change="getAppointDay"
          multiple
          placeholder="请选择"
          size="small"
          style="width: auto"
          transfer
          v-if="type=='4'"
          v-model="appointDay"
        >
          <Option :key="j" :label="j+'日'" :value="j" v-for="j in 31"></Option>
        </Select>
      </div>
      <div class="box-bottom">
        <Radio border label="14" size="small">指定周</Radio>
        <Select
          @on-change="getAppointWeek"
          multiple
          placeholder="请选择"
          size="small"
          style="width: auto"
          transfer
          v-if="type=='14'"
          v-model="appointWeek"
        >
          <Option :key="j" :label="j" :value="j" v-for="j in 7"></Option>
        </Select>
        <!-- <CheckboxGroup class="second-minute-chekck-group" v-model="appointWeek" v-show="type == 14">
          <Checkbox :key="j" :label="j" @on-change="getAppointWeek" v-for="j in 7"></Checkbox>
        </CheckboxGroup>-->
      </div>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 类型
      type: "1",
      // 日-周期
      dayCycle: {
        start: 0,
        end: 0
      },
      // 日-循环
      dayLoop: {
        start: 0,
        end: 0
      },
      // 日-指定
      appointDay: [],
      // 日-工作日
      work: 1,
      // 周-周期
      weekCycle: {
        start: 0,
        end: 0
      },
      // 周-循环
      weekLoop: {
        start: 0,
        end: 0
      },
      // 周-月末星期几
      last: 1,
      // 周-指定
      appointWeek: [],
      // 周-转义
      weekFormat: {
        1: "天",
        2: "一",
        3: "二",
        4: "三",
        5: "四",
        6: "五",
        7: "六"
      },
      // 结果
      result: {
        day: "",
        week: ""
      }
    }
  },
  methods: {
    // 当前选项
    getValue (value) {
      // 清空指定的选择项
      this.appointWeek = []
      this.appointDay = []
      if (value == "1") {
        // 指定每天
        this.result.day = "*"
        // 星期则为？
        this.result.week = "?"
      } else if (value == "2") {
        // 指定日-周期
        this.result.day = this.dayCycle.start + "-" + this.dayCycle.end
        // 星期则为？
        this.result.week = "?"
      } else if (value == "3") {
        // 指定日-循环
        this.result.day = this.dayLoop.start + "/" + this.dayLoop.end
        // 星期则为？
        this.result.week = "?"
      } else if (value == "5") {
        // 指定工作日
        this.result.day = this.work + "W"
        // 星期则为？
        this.result.week = "?"
      } else if (value == "6") {
        // 月最后一天
        this.result.day = "L"
        // 星期则为？
        this.result.week = "?"
      } else if (value == "7") {
        // 月最后一个工作日
        this.result.day = "LW"
        // 星期则为？
        this.result.week = "?"
      } else if (value == "4") {
        // 指定日期-默认勾选0
        this.appointDay = [1]
        this.result.day = this.appointDay.join(",")
        // 星期则为？
        this.result.week = "?"
      } else if (value == "11") {
        // 指定每周
        this.result.week = "*"
        // 日则为？
        this.result.day = "?"
      } else if (value == "12") {
        // 指定周-周期
        this.result.week = this.weekCycle.start + "-" + this.weekCycle.end
        // 日则为？
        this.result.day = "?"
      } else if (value == "13") {
        // 指定周-循环
        this.result.week = this.weekLoop.end + "#" + this.weekLoop.start
        // 日则为？
        this.result.day = "?"
      } else if (value == "15") {
        // 指定周-月末周几
        this.result.week = this.last + "L"
        // 日则为？
        this.result.day = "?"
      } else if (value == "14") {
        // 指定日期-默认勾选0
        this.appointWeek = [1]
        this.result.week = this.appointWeek.join(",")
        // 日则为？
        this.result.day = "?"
      } else {
        console.log('none')
      }
      this.$emit("dayAndWeek", this.result)
    },
    // 日-周期
    getChangeDay () {
      this.type = "2"
      this.result.day = this.dayCycle.start + "-" + this.dayCycle.end
      this.result.week = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    },
    // 日-循环
    getLoopDay () {
      this.type = "3"
      this.result.day = this.dayLoop.start + "/" + this.dayLoop.end
      this.result.week = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    },
    // 日-指定工作日
    getworkDay () {
      this.type = "5"
      this.result.day = this.work + "W"
      this.result.week = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    },
    // 日-指定日期
    getAppointDay () {
      this.type = "4"
      this.appointWeek = []
      this.result.day = this.appointDay
        .sort((a, b) => {
          return a - b
        })
        .join(",")
      this.result.week = "?"
      this.$emit("dayAndWeek", this.result)
    },
    // 周-指定日期
    getAppointWeek () {
      this.type = "14"
      this.appointDay = []
      this.result.week = this.appointWeek
        .sort((a, b) => {
          return a - b
        })
        .join(",")
      this.result.day = "?"
      this.$emit("dayAndWeek", this.result)
    },
    // 周- 周期
    getChangeWeek () {
      this.type = "12"
      this.result.week = this.weekCycle.start + "-" + this.weekCycle.end
      this.result.day = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    },
    // 周- 循环-指定本月第几周星期几开始
    getLoopWeek () {
      this.type = "13"
      this.result.week = this.weekLoop.end + "#" + this.weekLoop.start
      this.result.day = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    },
    // 周-月末星期几
    getlastWeek () {
      this.type = "15"
      this.result.week = this.last + "L"
      this.result.day = "?"
      this.$emit("dayAndWeek", this.result)
      // 清空指定状态
      this.appointWeek = []
      this.appointDay = []
    }
  }
};
</script>